export default __webpack_public_path__ + "static/media/client3.cba6cff0.jpg";